import React from 'react'
import styled from 'styled-components'

import Button from 'components/reusable/button'
import SvgCrossMarkSolid from 'components/reusable/svg/svg_cross_mark_solid'

const StyledCloseBtn = styled(Button)`
  position: absolute;
  right: 16px;
  top: 16px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const ModalCloseButton = ({ onClose, className }) => {
  return (
    <StyledCloseBtn type="semantic-wrapper" onClick={onClose} className={className}>
      <SvgCrossMarkSolid size={18} />
    </StyledCloseBtn>
  )
}

export default ModalCloseButton
